@if (show) {
  <div class="modal-overlay" (click)="onClose()">
    <div class="modal-content large" (click)="$event.stopPropagation()">
      <app-header-actions
        [config]="headerConfig"
        [initialFilters]="{ searchTerm: searchTerm, selectedTag: '' }"
        (addClick)="onAddArchive()"
        (filtersChanged)="onSearchChange($event.searchTerm)"
        (searchCleared)="onSearchChange('')"
        (allFiltersCleared)="onSearchChange('')"
      ></app-header-actions>
      <app-item-list
        [items]="filteredArchives"
        [config]="listConfig"
        [loading]="false"
        [hasActiveFilters]="!!searchTerm"
      ></app-item-list>
    </div>
  </div>
}

@if (showAddModal) {
  <app-modal-interaction-archives-add
    [show]="showAddModal"
    [interactionId]="interactionId"
    (close)="onCloseAddModal()">
  </app-modal-interaction-archives-add>
}